import React from "react";
import "./page6.css";
import img1 from "../../assets/img1.png";
import img2 from "../../assets/img2.png";
import img3 from "../../assets/img3.png";

const page6 = () => {
  return (
    <div className="page6-main">
      <h2 style={{ color: "white", textAlign: "center", padding: "40px 0px" }}>
        THE <b>NEWS </b>FROM OUR <b>BLOG</b>
      </h2>
      <div className="page6-main1">
        <div className="page6-main2">
          <div className="p6-img">
            <img src={img1} alt="" />
          </div>
          <div className="p6-text p61">
            <h5>IT OPEN NEW DOORS FOR EMPLOYMENT CREATION</h5>
            <p>
              Unemployment creates a slew of issues. It leads to a lot of young
              people going in the wrong direction to combat this Problem of
              unemployment, RedPhantom has generated new job possibilities
            </p>
          </div>
        </div>
        <div className="page6-main2">
          <div className="p6-img">
            <img src={img2} alt="" />
          </div>
          <div className="p6-text p62">
            <h5>NANOTECHNOLOGY IS THE FUTURE</h5>
            <p>
              he future of Nanotechnology, there are both bright and gloomy
              areas. On the one hand, technical advancements, great government
              backing, increased private investment, and rising demand for
              smaller devices, to mention a few factors.
            </p>
          </div>
        </div>
        <div className="page6-main2">
          <div className="p6-img">
            <img src={img3} alt=""/>
          </div>
          <div className="p6-text p63">
            <h5>INDIA HAS DIRE NEED OF EXPERT <br /> CYBERSECURITY PROFESSINAL</h5>
            <p>
              With several recent incidents of data breach, India’s
              cybersecurity journey so far proves this demamnd but is the
              country ready to meet this demand and is it preparing a
              cybersecurity workforce.
            </p>
          </div>
        </div>
      </div>
      <div className="p6-btn">
        {/* <div> */}
        <div className="btn1">Enter your Email to subscribe <i class="fas fa-arrow-right" style={{paddingLeft:"30px"}}></i></div>
        {/* </div> */}
        {/* <FontAwesomeIcon icon="fa-solid fa-arrow-right" /> */}
        {/* <div> */}
        <div className="btn2">Read More <i class="fad fa-angle-double-right" style={{color:"#00BFFF"}}></i></div></div>
        <section className="sec">hello</section>
      {/* </div> */}
    </div>
  );
};

export default page6;
